const logger = require('../logger/logger.js');
var rmsApiProxyRetry = require('../api/rmsApiProxyRetry');

export async function publishMessage(message)
{
    try
    {
        logger.info("Sending a publish message request for worker channel");
        var url = `${rmsApiProxyRetry.getOrgContextToUrl()}/channels/worker.queue`;
        await rmsApiProxyRetry.post(url, message);
        logger.info("Successfully sent a publish message request for worker channel");
    }
    catch(error)
    {
        logger.error('Error occurred while sending publish message request for worker channel. ', {}, error)
    }
}

